module.exports = __webpack_public_path__ + "img/plus.4395fd98.svg";